import { CardsStack } from '../SharedComponent/CardsStack/CardsStack';
import { JobCardSkeleton } from '../SharedComponent/JobCard/JobCardSkeleton';

interface CareerFeedLoadingStateProps {
  length: number;
  keyPrefix: string;
}

export const CareerFeedLoadingState: React.FC<CareerFeedLoadingStateProps> = ({
  length,
  keyPrefix,
}) => {
  const skeletonCards = Array.from({ length }).map((_, index) => (
    <JobCardSkeleton key={`${keyPrefix}_${index}`} />
  ));
  return <CardsStack>{skeletonCards}</CardsStack>;
};
